import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

/**
 * Hook to determine if check-ins are configured for the current user/company.
 * Check-ins are considered configured when:
 * 1. The company has mandatory check-ins enabled (and past the effective date), OR
 * 2. The current user has a cadence set in their manager_check_in_settings
 *
 * @returns boolean - true if check-ins are configured, false otherwise
 */
export const useCheckInsConfigured = (): boolean => {
	const company = useCurrentCompany();
	const user = useCurrentUser();

	// Check if company has mandatory check-ins enabled
	const companyCheckInSettings = company?.check_in_settings;
	const isCompanyMandatory =
		companyCheckInSettings?.mandatory && (!companyCheckInSettings?.effective_date || new Date() >= new Date(companyCheckInSettings.effective_date));

	// Check if user has a cadence set
	const userHasCadence = !!user?.manager_check_in_settings?.cadence;

	return isCompanyMandatory || userHasCadence;
};
